import { render, staticRenderFns } from "./lics.vue?vue&type=template&id=462ec848&"
import script from "./lics.vue?vue&type=script&lang=js&"
export * from "./lics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports